import { createApp } from 'vue'
import './style.css'
import "vant/lib/index.css";
import App from './App.vue'
import router from "./router/index";
import i18n from "./i18n";

const app = createApp(App)
  .use(router)
  .use(i18n)
app.mount('#app')